import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.less"],
  imports: [ MatButtonModule, MatIconModule]
})
export class SuccessComponent {
  private router: Router;

  public constructor() {
    this.router = inject(Router);
  }

  public async toHome(): Promise<void> {
    await this.router.navigate(["/quickscan"]);
    window.location.reload();
  }
}
